import { GetServerSideProps } from 'next';
import { MainLayout, SocialHeadData, ViewProjectUpdateModalController } from '@Components';
import { FunderProfilePageController } from '@Views';
import { fetchServerSideData, getFunderProfilePath } from '@Helpers';
import { FundingProfileData, ApiErrorObject, ProjectUpdate } from '@Types';
import { API } from '@Services';
import { QueryParams } from '@App/paths';

export const getServerSideProps: GetServerSideProps = async ({ params, query }) => {
  let props = {};
  if (params && Number(params.organizationId)) {
    let funderProfileData;
    const organizationId = Number(params.organizationId);
    funderProfileData = await fetchServerSideData<FundingProfileData & ApiErrorObject>(
      API.paths.public_funder_profile(organizationId),
    );

    if (funderProfileData.code === 'NOT_FOUND') {
      return { notFound: true };
    }

    props = { ...props, funderProfileData };
  }

  if (query[QueryParams.PROJECT_UPDATE]) {
    const projectUpdateId = Number(query[QueryParams.PROJECT_UPDATE]);
    const projectUpdateData = await fetchServerSideData<ProjectUpdate & ApiErrorObject>(
      API.paths.project_update(projectUpdateId),
    );

    if (projectUpdateData.code === 'NOT_FOUND') {
      return { notFound: true };
    }

    props = { ...props, projectUpdateData };
  }

  return { props };
};

interface FunderProfilePageProps {
  funderProfileData?: FundingProfileData;
  projectUpdateData?: ProjectUpdate;
}

const FunderProfilePage = ({ funderProfileData, projectUpdateData }: FunderProfilePageProps) => {
  return (
    <MainLayout>
      <SocialHeadData
        title={funderProfileData?.name}
        image={funderProfileData?.avatar_image}
        url={
          funderProfileData?.organization_id
            ? `https://www.actionfunder.org${getFunderProfilePath(
                funderProfileData.organization_id,
              )}`
            : ''
        }
        description={funderProfileData?.description}
      />
      {funderProfileData && (
        <FunderProfilePageController initialFunderProfileData={funderProfileData} />
      )}
      {projectUpdateData && (
        <ViewProjectUpdateModalController initialProjectUpdateData={projectUpdateData} />
      )}
    </MainLayout>
  );
};

export default FunderProfilePage;
